import React, { useEffect } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { trackEvent } from '../utils/analytics';

/**
 * Client-side handler for /go/band/:bandId
 *
 * The server-side Express route should intercept this URL first (logging the
 * scan and doing a 302 redirect before React loads), but if the server
 * falls through to the React catch-all this component handles it correctly.
 */
const QRRedirectPage: React.FC = () => {
  const { bandId } = useParams<{ bandId: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const view = searchParams.get('view') || 'public';

  useEffect(() => {
    if (!bandId) return;

    // Log the scan client-side (server-side route logs it if it intercepted first,
    // but in that case this component never renders so there's no double-count)
    trackEvent('qr_scan', { bandId, viewType: view });

    // Navigate to the actual band page
    const dest = view !== 'admin'
      ? `/band/${bandId}?view=${view}`
      : `/band/${bandId}`;

    navigate(dest, { replace: true });
  }, [bandId, view]);

  return null;
};

export default QRRedirectPage;
